export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата"])}
      },
      "en": {
        "date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Date"])}
      }
    }
  })
}
